import React, { Component } from 'react'
import AddressBlock from './AddressBlock'
import { RadioInput, TextInput } from './Form'
import { DumbField, getValidityClass, InfoMessage } from '../Field'
import FieldTooltip from '../Tooltip'
import { Result } from '../../ResultsDrawer/ResultsDrawer'
import Portal from 'components/Portal/Portal'
import { Modal } from '../../Modal/Modal'
import SearchControl from './SearchControl'
import PlusIcon from '@tecuity/sos-icons/react/plus-heavy'
import { VALIDATE } from '../validate'
import { noop, FormattedAddress } from 'utilities'
import { getAddressObject, resolveAgentMailingAddress } from 'components/Wizard2/WizardClasses'
import { Spinner } from 'components/Loaders/Loaders'

const RA_NONCOMMERCIAL_LABEL = process.env.RA_NONCOMMERCIAL_LABEL
const RA_ADDRESS_LABEL = process.env.RA_ADDRESS_LABEL

export default class RegisteredAgentSearch extends Component {
  constructor(props) {
    super()

     let recordNum = undefined
    if (window.location.href.indexOf('amend') > 0 || window.location.href.indexOf('correct') > 0) {
      let currentUrl = window.location.href.split('/')
      recordNum = currentUrl[currentUrl.length - 1] || null
    }

    this.state = {
      search: '',
      recordNum: recordNum || props.recordNum,
      modalOpen: false,
      results: {},
      filter: '',
    }
    this.searchRef = React.createRef()
  }
  componentDidMount = () => {
    if (this.props.isFirst && !this.props.disabled && this.focusTarget) {
      this.focusTarget.focus()
    }
  }
  onChange = (value, e) => {
    this.props.onChange({ ...this.props.value, [e.target.name]: value }, e)
  }
  onOrgYnChange = (value) => {
    this.props.onChange(
      { ...this.props.value, 
        ORG_YN: value, 
        MAIL_ADDR: getAddressObject(), 
        ...getAddressObject(),
        STATE: this.props.defaultState},
      {}
    )
  }
  setAddressValue = (address) => {
    this.props.onChange({ ...this.props.value, ...address }, {})
  }
  setMailAddressValue = (address) => {
    this.props.value.MAIL_ADDR = address
    this.props.onChange({ ...this.props.value }, {})
  }
  toggleModal = () => {
    this.setState({ modalOpen: !this.state.modalOpen })
  }
  checkForSubmit = ({ charCode }) => {
    if (charCode === 13) {
      this.search()
    }
  }
  filter = (e) => {
    this.setState({ filter: e.target.value })
  }
  onFilterKeyUp = ({ keyCode }) => {
    if (keyCode === 27) {
      this.setState({ modalOpen: false })
      this.searchRef.current.focus()
    }
  }
  selectResult = (result) => {
    this.props.onChange(
      {
        ...this.props.value,
        SELECTED: result,
        CRA_ID: result.SOURCE_ID,
        ...result,
        TYPE_ID: this.props.value.TYPE_ID,
      },
      {}
    )
    this.toggleModal()
  }
  deSelect = () => {
    this.props.onChange(
      {
        ...this.props.value,
        SELECTED: null,
        CRA_ID: '0',
        STATE: this.props.defaultState,
      },
      {}
    )
  }
  openAgentModal = () => {
    this.props.onChange(this.props.value, {}, { addingAgent: true })
    this.agentModal.open()
  }
  setGlobalModalFlagOff = () => {
    this.props.onChange(this.props.value, {}, { addingAgent: false })
    // this.clearNewAgent()
  }
  setNewAgentResult = () => {
    this.props.onChange(
      {
        ...this.props.value,
        NEW: true,
        ORGANIZATION: this.props.value.ORG_YN === false ? null : this.props.value.ORGANIZATION,
        FIRST_NAME: this.props.value.ORG_YN === false ? this.props.value.FIRST_NAME : '',
        MIDDLE_NAME: this.props.value.ORG_YN === false ? this.props.value.MIDDLE_NAME : '',
        LAST_NAME: this.props.value.ORG_YN === false ? this.props.value.LAST_NAME : '',
      },
      {},
      { selected: null }
    )
  }
  clearNewAgent = () => {
    this.props.onChange({
      ...this.props.value,
      NEW: false,
      ORG_YN: false,
      FIRST_NAME: '',
      MIDDLE_NAME: '',
      LAST_NAME: '',
      SUFFIX: '',
      ORGANIZATION: '',
      ...getAddressObject(),
      STATE: this.props.value.STATE,
      MAIL_ADDR: resolveAgentMailingAddress(this.props.value),
    })
  }
  render() {
    const {
      value,
      required,
      disabled,
      showMailingAddress,
      showEmail,
      showWebsite,
      searchPlaceholder,
      metadata,
      fieldId,
      description,
      sectionLabel,
      agentType1Label,
      agentType2Label,
      tooltip,
      modalOrgLabel,
      modalShowSuffix,
      typeSelectionDisabled,
      requireSearchValue,
    } = this.props


    let registeredAgentAddressBusinessRule = this.props.businessRules.find(
      (x) => x.fn === 'registeredAgentAddressIsValid'
    )

    let registeredAgentMailingAddressBusinessRule = this.props.businessRules.find(
      (x) => x.fn === 'registeredAgentMailingAddressIsValid'
    )

    const addressRequired = !!this.props.businessRules.find(
      (x) => x.fn === 'registeredAgentAddressIsValid'
    )
    const mailingAddressRequired = !!this.props.businessRules.find(
      (x) => x.fn === 'registeredAgentMailingAddressIsValid'
    )

    let orgAddressInputRequired = false
    let orgMailingAddressInputRequired = false
    if(addressRequired){
      orgAddressInputRequired = !!registeredAgentAddressBusinessRule.props.organizationAddressRequired
    }
    if(mailingAddressRequired){
      orgMailingAddressInputRequired = !!registeredAgentMailingAddressBusinessRule.props.organizationAddressRequired
    }

    const physicalAddressSection = this.props.value.ORGANIZATION?.SECTIONS?.find(
      (x) => x.label === 'Physical Address'
    );

    const physicalAddressLine =
      value.ORG_YN && !orgAddressInputRequired && physicalAddressSection
        ? physicalAddressSection.lines[0].line
        : ((orgAddressInputRequired || value.ORG_YN === false) && value.ADDR1)
          ? <FormattedAddress value={value} />
          : null;

    const mailingAddressSection = this.props.value.ORGANIZATION?.SECTIONS?.find(
      (x) => x.label === 'Mailing Address'
    );

    const mailingAddressLine =
      showMailingAddress && value.ORG_YN && !orgMailingAddressInputRequired && mailingAddressSection
        ? mailingAddressSection.lines[0].line
        : (showMailingAddress && (orgMailingAddressInputRequired || value.ORG_YN === false) && value.MAIL_ADDR?.ADDR1)
          ? <FormattedAddress value={value.MAIL_ADDR} />
          : null;

    return (
      <div className="block-wrapper registered-agent-search">
        {!value.SELECTED && !value.NEW ? (
          <div className="row">
            <div className="col-12">
              <div className={`sub-section ${required ? 'required' : ''}`}>
                <h3>
                  {sectionLabel || 'Search for registered agent'}
                  {tooltip && <FieldTooltip tooltip={tooltip} />}
                </h3>
                {description && <p className="description">{description}</p>}
                {!typeSelectionDisabled && (
                  <DumbField label="Select an agent type" className="reg-type" ownsLabel>
                    <RadioInput
                      label="Select an agent type"
                      ownsLabel
                      onChange={this.onChange}
                      name="TYPE_ID"
                      options={[
                        { value: '1', label: agentType1Label || 'Commercial' },
                        {
                          value: '2',
                          label: agentType2Label || RA_NONCOMMERCIAL_LABEL || 'Noncommercial',
                        },
                      ]}
                      fieldId="TYPE_ID"
                      value={value.TYPE_ID.toString()}
                      disabled={disabled}
                      leftAlign={true}
                      ref={(focusTarget) => {
                        this.focusTarget = focusTarget
                      }}
                    />
                  </DumbField>
                )}
                {value.TYPE_ID && (
                  <div className="row">
                    <div className="col-lg-8 col-md-9 col-sm-10 col-xs-12 search-column">
                      <DumbField
                        label="Name of individual or organization"
                        fieldId={`cra-search-${fieldId}`}
                      >
                        <SearchControl
                          fieldId={`cra-search-${fieldId}`}
                          name="ORGANIZATION"
                          placeholder={searchPlaceholder}
                          additionalParameters={{
                            INCLUDE_CRA_0_YN: 'N',
                            INCLUDE_CRA_1_YN: 'N',
                            TYPE_ID: value.TYPE_ID,
                            RecordNum: this.state.recordNum,
                          }}
                          searchType="ActiveRegisteredAgents"
                          onChange={this.selectResult}
                          modalTitle="Select a Registered Agent"
                          value={value.SELECTED}
                          width="100%"
                          requireSearchValue={requireSearchValue}
                          disabled={disabled}
                        />
                      </DumbField>
                    </div>
                  </div>
                )}
                {(value.TYPE_ID === '2' || value.TYPE_ID === 2) && (
                  <div className="row">
                    <div className="col-12 new-col">
                      <span>or </span>
                      <button
                        type="button"
                        className="btn btn-medium-neutral add"
                        onClick={this.openAgentModal}
                        disabled={disabled}
                      >
                        <PlusIcon /> Add New Agent
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        ) : null}
        {value.TYPE_ID.toString() === '2' && !value.SELECTED && !this.state.loading ? (
          <div className="block-wrapper" />
        ) : (
          value.SELECTED && (
            <div className="row">
              <div className="col-md-8 col-lg-7">
                <Result
                  className={`static static-selected-result animated ${
                    !disabled ? 'fadeInUp' : ''
                  } fast-animation`}
                  data={value.SELECTED}
                >
                  {!disabled && (
                    <button
                      type="button"
                      className="close"
                      onClick={this.deSelect}
                      ref={(focusTarget) => {
                        this.focusTarget = focusTarget
                      }}
                    >
                      <span className="icon icon-close" />
                    </button>
                  )}
                </Result>
              </div>
            </div>
          )
        )}
        {value.NEW && (
          <div className="row">
            <div className="col-md-8 col-lg-7">
              <Result
                className={`static static-selected-result animated ${
                  !disabled ? 'fadeInUp' : ''
                } fast-animation`}
                data={{
                  HEADER1:
                    value.ORG_YN === false
                      ? `${value.FIRST_NAME} ${value.MIDDLE_NAME ? `${value.MIDDLE_NAME} ` : ''}${
                          value.LAST_NAME
                        }`
                      : value.ORGANIZATION.HEADER1,
                  HEADER2: 
                    value.ORG_YN === false 
                    ? "Individual"
                    : value.ORGANIZATION.HEADER2,
                  SECTIONS: [
                    ...(showEmail && value.EMAIL
                      ? [
                          {
                            label: 'Email',
                            lines: [
                              {
                                line: value.EMAIL,
                              },
                            ],
                          },
                        ]
                      : []),
                    ...(showWebsite && value.WEBSITE
                      ? [
                          {
                            label: 'Website',
                            lines: [
                              {
                                line: value.WEBSITE,
                              },
                            ],
                          },
                        ]
                      : []),

                    ...(physicalAddressLine ? [{
                      label: RA_ADDRESS_LABEL || 'Physical Address',
                      lines: [{ line: physicalAddressLine }],
                    }] : []),

                    ...(mailingAddressLine ? [{
                      label: 'Mailing Address',
                      lines: [{ line: mailingAddressLine }],
                    }] : []),
                  ],
                }}
              >
                {!disabled && (
                  <button
                    type="button"
                    className="close"
                    onClick={this.clearNewAgent}
                    ref={(focusTarget) => {
                      this.focusTarget = focusTarget
                    }}
                  >
                    <span className="icon icon-close" />
                  </button>
                )}
              </Result>
            </div>
          </div>
        )}
        <AddAgentModal
          modalOrgLabel={modalOrgLabel}
          modalShowSuffix={modalShowSuffix}
          value={value}
          metadata={metadata}
          showMailingAddress={showMailingAddress}
          showEmail={showEmail}
          showWebsite={showWebsite}
          fieldId={fieldId}
          onFieldChange={this.onChange}
          onOrgYnChange={this.onOrgYnChange}
          onPrimaryAddressChange={this.setAddressValue}
          onMailingAddressChange={this.setMailAddressValue}
          onSave={this.setNewAgentResult}
          onClose={this.setGlobalModalFlagOff}
          onCancel={this.clearNewAgent}
          recordNum={this.state.recordNum}
          parentProps={this.props}
          businessRules={this.props.businessRules}
          ref={(ref) => {
            this.agentModal = ref
          }}
          requireSearchValue={requireSearchValue}
        />
      </div>
    )
  }
}

class AddAgentModal extends Component {
  state = {
    open: false,
    errorMessage: [],
    // Individual valid flags to control valid/invalid highlighting of specific fields.
    validation: {
      validAgentName: null,
      validAgentOrg: null,
      validAddress: null,
      validMailAddress: null,
      infoMessage: null,
    },
  }
  open = () =>
    this.setState({
      open: true,
      errorMessage: [],
      validation: {
        validAgentName: null,
        validAgentOrg: null,
        validAddress: null,
        validMailAddress: null,
        infoMessage: null,
      },
    })
  close = () => {
    this.setState({ open: false })
    this.props.onClose()
  }
  validate = (callback) => {
    /* 
      Previously, the validation was running through the validateFieldArray logic that all typical wizard fields run through when "onAdvance"
      validation is called. This was a problem though, because it was treating the entire modal as a single field (instead of multiple addressBlocks,
      a name, and some textboxes), so there was no way to highlight incorrect fields to the customer when validation failed. The logic in this method
      now looks at the businessRules assigned to this field and performs its own validation to provide helpful feedback to the customer.

      These are the business rules that are available to this field.
      'registeredAgentIsRequired', - this will be validated by the wizard "onAdvance" step
      'registeredAgentNotSoS', - don't need to validate this here since this CRA_ID can only be selected when choosing an existing one
      'registeredAgentAddressIsValid', - only do this one when it's configured
      'poBoxNotAllowed', - only do this one when it's configured
      'mailingPoBoxNotAllowed', - only do this one when it's configured
      'checkAgentNameForRegulatedWords', - only do this one when it's configured
      'registeredAgentMailingAddressIsValid', - only do this one when it's configured
      'customBusinessRules' - don't worry about this one,
    */
    let agentAddressIsValidRule = this.props.businessRules.find(
      (x) => x.fn === 'registeredAgentAddressIsValid'
    )
    let agentMailingAddressIsValidRule = this.props.businessRules.find(
      (x) => x.fn === 'registeredAgentMailingAddressIsValid'
    )

    let poBoxRule = this.props.businessRules.find((x) => x.fn === 'poBoxNotAllowed')
    let mailingPoBoxRule = this.props.businessRules.find((x) => x.fn === 'mailingPoBoxNotAllowed')
    let regulatedWordsRule = this.props.businessRules.find(
      (x) => x.fn === 'checkAgentNameForRegulatedWords'
    )

    let messages = []
    let promises = []
    let newValidation = {}
    let isValid = true
    if (agentAddressIsValidRule) {
      promises.push(
        new Promise((resolve) => {
          VALIDATE.registeredAgentAddressIsValid(
            this.props.value,
            { addingAgent: true },
            agentAddressIsValidRule.props,
            (valid, errorMessage, validationProps) => {
              resolve({
                valid,
                errorMessage,
                validationProps,
                callback: (props) => {
                  if (props.addressCorrected) {
                    this.props.onPrimaryAddressChange(getAddressObject(props.value))
                  }
                },
              })
            }
          )
        })
      )
    }
    if (agentMailingAddressIsValidRule) {
      promises.push(
        new Promise((resolve) => {
          VALIDATE.registeredAgentMailingAddressIsValid(
            this.props.value,
            { addingAgent: true },
            agentMailingAddressIsValidRule.props,
            (valid, errorMessage, validationProps) => {
              resolve({
                valid,
                errorMessage,
                validationProps,
                callback: (props) => {
                  if (props.mailAddressCorrected && props.value.MAIL_ADDR) {
                    this.props.onMailingAddressChange(props.value.MAIL_ADDR)
                  }
                },
              })
            }
          )
        })
      )
    }
    if (this.props.value.ORG_YN) {
      promises.push(
        new Promise((resolve) => {
          VALIDATE.selectedAgentOrganization(
            this.props.value,
            { addingAgent: true, defaultState: this.props.parentProps.defaultState },
            {},
            (valid, errorMessage, validationProps) => {
              resolve({ valid, errorMessage, validationProps })
            }
          )
        })
      )
    }
    if (poBoxRule && !this.props.value.ORG_YN) {
      promises.push(
        new Promise((resolve) => {
          VALIDATE.poBoxNotAllowed(
            this.props.value,
            { addingAgent: true, defaultState: this.props.parentProps.defaultState },
            { ...poBoxRule.props, errorMessage: poBoxRule.props.errorMessage },
            (valid, errorMessage, validationProps) => {
              resolve({ valid, errorMessage, validationProps })
            }
          )
        })
      )
    }
    if (mailingPoBoxRule) {
      promises.push(
        new Promise((resolve) => {
          VALIDATE.mailingPoBoxNotAllowed(
            this.props.value,
            { addingAgent: true, defaultMailState: this.props.parentProps.defaultMailState },
            {
              ...mailingPoBoxRule.props,
              errorMessage:
                mailingPoBoxRule.props.errorMessage || 'Mailing address may not contain PO Box',
            },
            (valid, errorMessage, validationProps) => {
              resolve({ valid, errorMessage, validationProps })
            }
          )
        })
      )
    }
    if (regulatedWordsRule && this.props.value.ORG_YN === false) {
      promises.push(
        new Promise((resolve) => {
          VALIDATE.checkAgentNameForRegulatedWords(
            this.props.value,
            {},
            regulatedWordsRule.props,
            (valid, errorMessage, validationProps) => {
              resolve({ valid, errorMessage, validationProps })
            }
          )
        })
      )
    }
    if (this.props.showEmail) {
      promises.push(
        new Promise((resolve) => {
          VALIDATE.isValidEmailFormat(
            this.props.value.EMAIL,
            {},
            {},
            (valid, errorMessage, validationProps) => {
              if (valid !== true) {
                resolve({
                  valid: false,
                  errorMessage: 'Please enter a properly formatted email address.',
                  validationProps: { ...validationProps, validEmail: false },
                })
              } else {
                resolve({
                  valid,
                  errorMessage,
                  validationProps: { ...validationProps, validEmail: true },
                })
              }
            }
          )
        })
      )
    }

    Promise.all(promises)
      .then((results) => {
        results.forEach((result) => {
          if (result.callback && typeof result.callback === 'function') {
            result.callback(result.validationProps)
          }
          isValid = isValid && result.valid
          if (result.errorMessage && result.errorMessage.trim() !== '') {
            messages.push(result.errorMessage)
          }
          newValidation = this.mergeValidationProps(newValidation, result.validationProps)
        })
      })
      .then(() => {
        this.setState({
          errorMessage: messages,
          validating: false,
          validation: { ...this.state.validation, ...newValidation },
        })
        callback(isValid)
      })
  }
  mergeValidationProps = (oldProps, newProps) => {
    Object.keys(newProps).forEach((key) => {
      // If oldProps has already calculated 'false' for this prop, maintain false
      if (oldProps[key] === false) {
        newProps[key] = false
      }
    })

    return { ...oldProps, ...newProps }
  }
  save = () => {
    this.setState({
      validating: true,
      validation: {
        validAgentName: null,
        validAgentOrg: null,
        validAddress: null,
        validMailAddress: null,
        infoMessage: null,
      },
    })
    this.validate((isValid) => {
      if (isValid) {
        this.modal.closeModal()
        this.props.onSave()
      }
    })
  }
  removeErrorDuplicates = () => {
    const { errorMessage } = this.state
    const hashTable = errorMessage.reduce((obj, e) => ({ ...obj, [e]: true }), {})
    return Object.keys(hashTable)
  }
  render() {
    const {
      value,
      modalOrgLabel,
      modalShowSuffix,
      showMailingAddress,
      showEmail,
      showWebsite,
      metadata,
      fieldId,
      parentProps,
      onFieldChange,
      onOrgYnChange,
      onPrimaryAddressChange,
      onMailingAddressChange,
      searchPlaceholder,
      recordNum,
      requireSearchValue,
    } = this.props

    let registeredAgentAddressBusinessRule = this.props.businessRules.find(
      (x) => x.fn === 'registeredAgentAddressIsValid'
    )

    let registeredAgentMailingAddressBusinessRule = this.props.businessRules.find(
      (x) => x.fn === 'registeredAgentMailingAddressIsValid'
    )

    const addressRequired = !!this.props.businessRules.find(
      (x) => x.fn === 'registeredAgentAddressIsValid'
    )
    const mailingAddressRequired = !!this.props.businessRules.find(
      (x) => x.fn === 'registeredAgentMailingAddressIsValid'
    )

    let orgAddressInputRequired = false
    let orgMailingAddressInputRequired = false
    if(addressRequired){
      orgAddressInputRequired = !!registeredAgentAddressBusinessRule.props.organizationAddressRequired
    }
    if(mailingAddressRequired){
      orgMailingAddressInputRequired = !!registeredAgentMailingAddressBusinessRule.props.organizationAddressRequired
    }

    return (
      <Portal isOpened={this.state.open}>
        <Modal
          title="Add New Agent"
          closeModal={this.close}
          cancel={this.props.onCancel}
          modalSize="medium"
          modalBodyClassName="wizard relative-modal"
          saveAndCloseButton={false}
          cancelButton
          // closeButton
          ref={(ref) => {
            this.modal = ref
          }}
        >
          <div className="template sub-section registered-agent-modal">
            <DumbField label="This Agent is an: ">
              <RadioInput
                onChange={(val) => onOrgYnChange(JSON.parse(val))}
                name="ORG_YN"
                fieldId="ORG_YN"
                options={[
                  { value: false, label: 'Individual' },
                  { value: true, label: modalOrgLabel || 'Organization' },
                ]}
                value={value.ORG_YN}
                leftAlign={true}
              />
            </DumbField>
            {value.ORG_YN === false ? (
              <div className="row">
                <div className="col-sm-4">
                  <DumbField label="First Name" required>
                    <TextInput
                      autoComplete="given-name"
                      validityClass={getValidityClass(this.state.validation.validAgentName)}
                      value={value.FIRST_NAME}
                      name="FIRST_NAME"
                      onChange={onFieldChange}
                      onBlur={noop}
                      width="100%"
                    />
                  </DumbField>
                </div>
                <div className="col-sm-3 col-md-2">
                  <DumbField label="Middle/Initial">
                    <TextInput
                      autoComplete="additional-name"
                      value={value.MIDDLE_NAME}
                      name="MIDDLE_NAME"
                      onChange={onFieldChange}
                      onBlur={noop}
                      width="100%"
                    />
                  </DumbField>
                </div>
                <div className="col-sm-4 col-md-4">
                  <DumbField label="Last Name" required>
                    <TextInput
                      autoComplete="family-name"
                      validityClass={getValidityClass(this.state.validation.validAgentName)}
                      value={value.LAST_NAME}
                      name="LAST_NAME"
                      onChange={onFieldChange}
                      onBlur={noop}
                      width="100%"
                    />
                  </DumbField>
                </div>
                {modalShowSuffix && (
                  <div className="col-sm-2 col-md-2">
                    <DumbField label="Suffix">
                      <TextInput
                        autoComplete="honorific-suffix"
                        value={value.SUFFIX}
                        name="SUFFIX"
                        onChange={onFieldChange}
                        onBlur={noop}
                        width="100%"
                      />
                    </DumbField>
                  </div>
                )}
              </div>
            ) : (
              <div className="row">
                <div className="col-sm-11 col-md-10 col-lg-9">
                  <DumbField label="Organization" required>
                    <SearchControl
                      name="ORGANIZATION"
                      searchType="AgentOrganizations"
                      metadata={metadata}
                      onChange={onFieldChange}
                      modalTitle="Search Valid Organizations"
                      value={value.ORGANIZATION}
                      placeholder={searchPlaceholder}
                      width="100%"
                      additionalParameters={{ RecordNum: recordNum }}
                      isValid={this.state.validation.validAgentOrg}
                      requireSearchValue={requireSearchValue}
                    />
                  </DumbField>
                </div>
              </div>
            )}
            {value.ORG_YN === false && this.state.validation.infoMessage ? (
              <InfoMessage>{this.state.validation.infoMessage}</InfoMessage>
            ) : null}

            {(value.ORG_YN === false || orgAddressInputRequired) ? (
              <DumbField
                className="cra-address"
                label={RA_ADDRESS_LABEL ? `${RA_ADDRESS_LABEL}:` : 'Physical Address:'}
              >
                <AddressBlock
                  {...parentProps}
                  singleColSize="col-sm-11 col-md-10 col-lg-9"
                  triColSizes={{
                    CITY: 'col-sm-5 col-md-4 col-lg-3',
                    STATE: 'col-sm-3 col-md-3 col-lg-3',
                    POSTAL_CODE: '"col-sm-3 col-md-3 col-lg-3"',
                  }}
                  isFirst={false}
                  fieldId={`${fieldId}_PRIMARY`}
                  required={addressRequired}
                  disableState={
                    process.env.RA_PRINCIPLE_STATE_DISABLED !== undefined
                      ? process.env.RA_PRINCIPLE_STATE_DISABLED
                      : parentProps.disableState
                  }
                  value={{
                    ADDR1: value.ADDR1,
                    ADDR2: value.ADDR2,
                    ADDR3: value.ADDR3,
                    CITY: value.CITY,
                    STATE: value.STATE,
                    COUNTY: value.COUNTY,
                    COUNTRY: value.COUNTRY,
                    POSTAL_CODE: value.POSTAL_CODE,
                  }}
                  onChange={onPrimaryAddressChange}
                  isValid={this.state.validation.validAddress}
                />
              </DumbField>
            ) : null}

            {showMailingAddress
            && (value.ORG_YN === false || orgMailingAddressInputRequired)
              ? (
              <DumbField className="cra-address" label="Mailing Address:">
                <AddressBlock
                  {...parentProps}
                  singleColSize="col-sm-11 col-md-10 col-lg-9"
                  triColSizes={{
                    CITY: 'col-sm-5 col-md-4 col-lg-3',
                    STATE: 'col-sm-3 col-md-3 col-lg-3',
                    POSTAL_CODE: '"col-sm-3 col-md-3 col-lg-3"',
                  }}
                  isValid={this.state.validation.validMailAddress}
                  isFirst={false}
                  fieldId={`${fieldId}_MAIL`}
                  required={mailingAddressRequired}
                  disableState={
                    process.env.RA_MAILING_STATE_DISABLED !== undefined
                      ? process.env.RA_MAILING_STATE_DISABLED
                      : parentProps.disableMailingState
                  }
                  value={{
                    ADDR1: value.MAIL_ADDR.ADDR1,
                    ADDR2: value.MAIL_ADDR.ADDR2,
                    ADDR3: value.MAIL_ADDR.ADDR3,
                    CITY: value.MAIL_ADDR.CITY,
                    STATE: value.MAIL_ADDR.STATE,
                    COUNTY: value.MAIL_ADDR.COUNTY,
                    COUNTRY: value.MAIL_ADDR.COUNTRY,
                    POSTAL_CODE: value.MAIL_ADDR.POSTAL_CODE,
                  }}
                  onChange={onMailingAddressChange}
                />
              </DumbField>
            ) : null}
            {showEmail && (
              <div className="row">
                <div className="col-md-7 col-lg-5">
                  <DumbField label="Email" required>
                    <TextInput
                      validityClass={getValidityClass(this.state.validation.validEmail)}
                      value={value.EMAIL}
                      name="EMAIL"
                      onChange={onFieldChange}
                      onBlur={noop}
                      width="100%"
                    />
                  </DumbField>
                </div>
              </div>
            )}
            {showWebsite && (
              <div className="row">
                <div className="col-md-7 col-lg-5">
                  <DumbField label="Website">
                    <TextInput
                      value={value.WEBSITE}
                      name="WEBSITE"
                      onChange={onFieldChange}
                      onBlur={noop}
                      width="100%"
                    />
                  </DumbField>
                </div>
              </div>
            )}
            {this.state.errorMessage &&
              this.removeErrorDuplicates().map((errorMessage, i) => (
                <p className="field-error animated fadeIn fast-animation standalone-error" key={i}>
                  {errorMessage}
                </p>
              ))}
            <div className="controls">
              <button type="button" className="btn btn-raised btn-primary" onClick={this.save}>
                {this.state.validating ? (
                  <Spinner size="small" themeColor="dark-neutral" />
                ) : (
                  'Save'
                )}
              </button>
            </div>
          </div>
        </Modal>
      </Portal>
    )
  }
}
